
import { Maskable } from "models/domain/interfaces/maskable";
import formatWithMask from "utils/masks/format-with-masks";
import masks from "utils/masks/masks";
import { removeMasks } from "utils/remove-masks";

export class Zipcode implements Maskable {
    private static readonly zipcodeRegex = /^(\d{8}|\d{2}\.?\d{3}-\d{3})$/i;
    private value: string;

    private constructor(value: string) {
        this.value = value;
    }

    public static fromString(value: string) {
        value = removeMasks(value.trim().toLowerCase());
        if (!value) {
            throw new Error('E-mail é obrigatório.');
        }

        if (value.length !== 8) {
            throw new Error('E-mail muito curto');
        }

        if (!this.zipcodeRegex.test(value)) {
            throw new Error('E-mail inválido.');
        }

        return new Zipcode(value);
    }


    public getWithMask() {
        const { masked } = formatWithMask({
            mask: masks.ZIP_CODE,
            text: this.value
        });
        return masked;
    }

    public getWithoutMask() {
        return removeMasks(this.value);
    }
}